// User
export const _userData = state => state.user.userData;
export const _activeOrg = state => state.user.activeOrg;
export const _activePermissions = state => state.user.activePermissions;

// Access
export const _accessLog = state => state.access.accessLog;
export const _lastCursor = state => state.access.lastCursor;
export const _hasMoreAccessLog = state => state.access.hasMore;
export const _accessError = state => state.access.error;

// Orgs
export const _orgs = state => state.org.orgs;
export const _selectedOrg = state => state.org.selectedOrg;
export const _orgProperties = state => state.properties.orgProperties;
export const _invitedMembers = state => state.manager.invitedMembers;

// Init
export const _appInitialized = state => state.init.appInitialized;

// Manager
export const _communityMembers = state => state.manager.communityMembers;
export const _unassignedDevices = state => state.manager.unassignedDevices;
export const _orgInvitesV2 = state => state.manager.orgInvitesV2;
export const _orgInviteMembers = state => state.manager.orgInviteMembers;
export const _orgInviteOperators = state => state.manager.orgInviteOperators;
export const _orgInviteGuests = state => state.manager.orgInviteGuests;

// Router
export const _getCurrentRoute = state => state.router.location.pathname;

// Intercom
export const _getActiveIntercom = state => state.coms.intercom;
export const _activeComs = state => state.coms.active;
export const _pendingComs = state => state.coms.pending;

// Calls
export const _activeCalls = state => state.calls.active;
export const _pendingCalls = state => state.calls.pending;

// Snackbar
export const _getSnackbarOpen = state => state.snack.open;
export const _getSnackbarMessage = state => state.snack.message;
export const _getSnackbarIsGueard = state => state.snack.isGuardAlert;

// OTC
export const _otcCodes = state => state.otc.otcCodes;
